import React, {
    useState,
    useRef,
    useContext, useEffect,
} from "react";



import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import QRCode from "react-qr-code";
import Barcode from "react-barcode";

import "../components/LoadingReceipt.css";







function FurnacePerformance({ onClose }) {

    const [currentPage, setCurrentPage] = useState(0);

    const report =
    JSON.parse(
        localStorage.getItem("FURNACE_REPORT")
    ) || {};

const feed = report.feed || {};

const radiation = report.radiationZone || {};

const convection = report.convectionZone || {};

const airPreheater = report.airPreheater || {};

const stack = report.stack || {};

const crude = report.crude || {};

const steam = report.steam || {};

const fuel = report.fuel || {};

const performance =
    report.performance || {};

const furnaceStatus =
    performance.furnaceStatus || "";

const steamGenerationStatus =
    performance.steamGenerationStatus || "";

const radiationZoneStatus =
    performance.radiationZoneStatus || "";

const stackCondition =
    performance.stackCondition || "";

const furnaceDraftStatus =
    performance.furnaceDraftStatus || "";

const crudeTemperatureRise =
    performance.crudeTemperatureRise || 0;

const steamTemperatureRise =
    performance.steamTemperatureRise || 0;

const steamPressureDrop =
    performance.steamPressureDrop || 0;

const steamPerformance =
    performance.steamPerformance || "";

const fuelStatus =
    performance.fuelStatus || "";






    const [position, setPosition] = useState({
        x: 120,
        y: 40
    });

    const [dragging, setDragging] = useState(false);

    const offsetRef = useRef({
        x: 0,
        y: 0
    });

    const startDrag = (e) => {

        setDragging(true);

        offsetRef.current = {

            x: e.clientX - position.x,

            y: e.clientY - position.y

        };

    };


    const handleMouseMove = (e) => {

        if (!dragging) return;

        setPosition({

            x: e.clientX - offsetRef.current.x,

            y: e.clientY - offsetRef.current.y

        });

    };


    const stopDrag = () => {

        setDragging(false);

    };



    useEffect(() => {

        window.addEventListener(
            "mousemove",
            handleMouseMove
        );

        window.addEventListener(
            "mouseup",
            stopDrag
        );

        return () => {

            window.removeEventListener(
                "mousemove",
                handleMouseMove
            );

            window.removeEventListener(
                "mouseup",
                stopDrag
            );

        };

    }, [dragging]);


    console.log(
        "FURNACE REPORT",
        report
    );

    return (

        <div
            className="receipt-window"
            style={{
                left: position.x,
                top: position.y,
                width: "680px",
                height: "88vh",
                display: "flex",
                flexDirection: "column"
            }}
        >


            {/* HEADER */}

            <div
                className="receipt-header"
                onMouseDown={startDrag}
                style={{
                    cursor: "move"
                }}
            >

                <div>
                    NK TECH INDUSTRIAL DCS & DIGITAL TWIN SOLUTION
                </div>


                <button
                    className="receipt-close"
                    onClick={onClose}
                >
                    ✕
                </button>


            </div>





            <div className="receipt-scroll">

                {currentPage === 0 && (

                    <div className="receipt-page">

                        <div
                            style={{
                                textAlign: "center",
                                marginBottom: 30
                            }}
                        >

                            <div
                                style={{
                                    fontSize: 18,
                                    fontWeight: "bold",
                                    color: "#003366",
                                    letterSpacing: 1
                                }}
                            >
                                NK TECH NIGERIA LIMITED
                            </div>

                            <div
                                style={{
                                    fontSize: 14,
                                    marginTop: 4,
                                    color: "#666"
                                }}
                            >
                                NK REFINERY DIGITAL TWIN SYSTEM
                            </div>

                            <div
                                style={{
                                    fontSize: 13,
                                    marginTop: 4,
                                    color: "#666"
                                }}
                            >
                                PROCESS SIMULATION • DIGITAL LABORATORY • OPERATIONS MONITORING
                            </div>

                        </div>

                        <hr />

                        <div
                            style={{
                                textAlign: "center",
                                margin: "30px 0"
                            }}
                        >

                            <h1
                                style={{
                                    margin: 0,
                                    fontSize: 34,
                                    color: "#C0392B",
                                    letterSpacing: 2
                                }}
                            >
                                CRUDE FURNACE
                            </h1>

                            <h2
                                style={{
                                    marginTop: 10,
                                    marginBottom: 8,
                                    color: "#444",
                                    fontWeight: 600
                                }}
                            >
                                PERFORMANCE LABORATORY REPORT
                            </h2>

                            <div
                                style={{
                                    fontSize: 17,
                                    fontWeight: "bold",
                                    color: "#666"
                                }}
                            >
                                CRUDE HEATING FURNACE
                            </div>

                            <div
                                style={{
                                    marginTop: 10,
                                    fontSize: 13,
                                    color: "#888"
                                }}
                            >
                                Equipment Tag : H-201
                            </div>

                        </div>

                        <table
                            className="receipt-table"
                            style={{
                                marginTop: 50
                            }}
                        >

                            <tbody>

                                <tr>

                                    <td>Report Type</td>

                                    <td>
                                        Furnace Performance Report
                                    </td>

                                </tr>

                                <tr>

                                    <td>Plant</td>

                                    <td>
                                        NK Refinery Digital Twin
                                    </td>

                                </tr>

                                <tr>

                                    <td>Unit</td>

                                    <td>
                                        Atmospheric Distillation Unit
                                    </td>

                                </tr>

                                <tr>

                                    <td>Crude Feed Rate</td>

                                    <td>

                                        {Number(feed.flow || 0).toFixed(3)} m³/hr

                                    </td>

                                </tr>

                                <tr>

                                    <td>Crude Outlet Temperature</td>

                                    <td>

                                        {Number(crude.outletTemperature || 0).toFixed(2)} °C

                                    </td>

                                </tr>

                                <tr>

                                    <td>Steam Generation</td>

                                    <td>

                                        {performance.steamGenerationStatus}

                                    </td>

                                </tr>

                                <tr>

                                    <td>Overall Furnace Status</td>

                                    <td>

                                        {performance.furnaceStatus}

                                    </td>

                                </tr>

                                <tr>

                                    <td>Report Generated</td>

                                    <td>

                                        {report.generated}

                                    </td>

                                </tr>

                            </tbody>

                        </table>

                        <div
                            style={{
                                marginTop: 50,
                                display: "flex",
                                justifyContent: "space-around",
                                alignItems: "center"
                            }}
                        >

                            <QRCode

                                value={JSON.stringify({

                                    System:
                                        "NK REFINERY DIGITAL TWIN SYSTEM",

                                    Report:
                                        "FURNACE PERFORMANCE REPORT",

                                    Unit:
                                        "CRUDE FURNACE",

                                    ReportID:
                                        report.reportNumber,

                                    Date:
                                        report.generated

                                })}

                                size={120}

                            />

                            <Barcode

                                value={report.reportNumber}

                                width={1.5}

                                height={60}

                                fontSize={14}

                            />

                        </div>

                        <div
                            style={{
                                marginTop: 40,
                                textAlign: "justify",
                                fontStyle: "italic",
                                color: "#555",
                                lineHeight: 1.8
                            }}
                        >

                            This report has been generated automatically from the NK Refinery
                            Digital Twin System using real-time furnace operating parameters.
                            The report evaluates furnace operating conditions, crude heating
                            performance, combustion efficiency indicators, steam generation,
                            draft conditions and fuel utilization.

                            <br /><br />

                            The engineering assessment presented throughout this report follows
                            recommended operating practices contained within
                            <strong> API Standard 560 (Fired Heaters for General Refinery Service)</strong>,
                            <strong> API 530</strong>,
                            <strong> API RP 535</strong>,
                            together with good refinery operating practice.
                            The objective is to identify operating deviations before they affect
                            heater efficiency, fuel consumption, tube life, coking tendency,
                            combustion stability and overall refinery energy performance.

                        </div>

                    </div>

                )}


                {/* =========================================================
   PAGE 1
   FEED PREHEATING ANALYSIS
========================================================= */}

                {currentPage === 1 && (

                    <div>

                        <h2
                            style={{
                                textAlign: "center",
                                marginBottom: 15,
                                color: "#0b5ed7"
                            }}
                        >
                            PAGE 1 — FEED PREHEATING & HEAT ABSORPTION
                        </h2>


                        <table className="lab-table">

                            <tbody>

                                <tr>
                                    <td>Feed Flow</td>
                                    <td>{feed.flow?.toFixed(2)} m³/hr</td>
                                </tr>

                                <tr>
                                    <td>Feed Temperature</td>
                                    <td>{feed.temperature?.toFixed(1)} °C</td>
                                </tr>

                                <tr>
                                    <td>Feed Pressure</td>
                                    <td>{feed.pressure?.toFixed(2)} barg</td>
                                </tr>

                                <tr>
                                    <td>Crude Outlet Temperature</td>
                                    <td>{crude.outletTemperature?.toFixed(1)} °C</td>
                                </tr>

                                <tr>
                                    <td>Total Temperature Rise</td>
                                    <td>{crude.temperatureRise?.toFixed(1)} °C</td>
                                </tr>

                                <tr>
                                    <td>Radiation Zone Temperature</td>
                                    <td>{radiation.temperature?.toFixed(1)} °C</td>
                                </tr>

                                <tr>
                                    <td>Bridgewall Temperature</td>
                                    <td>{radiation.bridgewallTemperature?.toFixed(1)} °C</td>
                                </tr>

                            </tbody>

                        </table>

                        <br />

                        <div className="lab-notes">

                            <h3>Engineering Interpretation</h3>

                            <p>

                                The fired heater raises the crude oil temperature from the
                                preheat train outlet to the required furnace outlet
                                temperature before entering the Atmospheric Distillation
                                Column. The majority of heat transfer occurs inside the
                                radiant section where radiant heat from the burner flames
                                is absorbed directly by the process coils.

                            </p>

                            <p>

                                Bridgewall temperature is one of the most important
                                performance indicators of furnace firing severity.
                                Excessively high bridgewall temperature generally
                                indicates excessive firing rates, burner imbalance,
                                restricted heat absorption, coil fouling or poor draft
                                control.

                            </p>

                            <p>

                                The crude outlet temperature should remain sufficiently
                                high to provide adequate flash vaporization inside the
                                atmospheric column while remaining below the thermal
                                cracking temperature of the crude oil.

                            </p>

                            <p>

                                Typical refinery fired heaters operate with crude outlet
                                temperatures between approximately 330°C and 370°C,
                                depending upon crude type, furnace design and atmospheric
                                column operating objectives.

                            </p>

                            <p>

                                A continuously increasing temperature rise accompanied by
                                increasing bridgewall temperature normally indicates
                                healthy heat transfer. However, if bridgewall temperature
                                continues increasing while crude outlet temperature
                                remains nearly constant, inspection for internal coil
                                fouling or external coke deposition should be considered.

                            </p>

                            <h3>Engineering Standards</h3>

                            <ul>

                                <li>
                                    API 560 — Fired Heaters for General Refinery Service
                                </li>

                                <li>
                                    API 530 — Calculation of Heater Tube Thickness
                                </li>

                                <li>
                                    API RP 573 — Inspection of Fired Boilers and Heaters
                                </li>

                                <li>
                                    ASME Section VIII (Pressure Components)
                                </li>

                            </ul>

                        </div>

                    </div>

                )}


                {/* ==========================================================
   PAGE 2 – RADIATION SECTION PERFORMANCE
========================================================== */}

                {currentPage === 2 && (

                    <div>

                        <h2
                            style={{
                                textAlign: "center",
                                color: "#0b5ed7"
                            }}
                        >
                            RADIATION SECTION PERFORMANCE
                        </h2>

                        <table className="receipt-table">

                            <tbody>

                                <tr>
                                    <td>Radiant Coil Temperature</td>
                                    <td>
                                        {Number(radiation.temperature || 0).toFixed(1)} °C
                                    </td>
                                </tr>

                                <tr>
                                    <td>Bridgewall Temperature</td>
                                    <td>
                                        {Number(radiation.bridgewallTemperature || 0).toFixed(1)} °C
                                    </td>
                                </tr>

                                <tr>
                                    <td>Firebox Draft</td>
                                    <td>
                                        {Number(radiation.draftPressure || 0).toFixed(3)} kPag
                                    </td>
                                </tr>

                                <tr>
                                    <td>Damper Opening</td>
                                    <td>
                                        {Number(radiation.damperOpening || 0).toFixed(1)} %
                                    </td>
                                </tr>

                                <tr>
                                    <td>Operating Status</td>
                                    <td>
                                        {radiation.status || "N/A"}
                                    </td>
                                </tr>

                            </tbody>

                        </table>

                        <br />

                        <div
                            style={{
                                background: "#eef7ff",
                                padding: 20,
                                borderRadius: 8,
                                lineHeight: 1.8,
                                fontSize: 14
                            }}
                        >

                            <h3>Engineering Interpretation</h3>

                            <p>

                                The radiation section is the primary heat transfer region of the
                                crude furnace where thermal energy from the burner flames is
                                transferred mainly by radiation to the process coils.
                                Approximately 70–80% of the total furnace duty is normally
                                absorbed within this section.

                            </p>

                            <p>

                                Radiant coil temperature provides an indication of furnace firing
                                intensity and heat absorption. Stable temperatures generally
                                indicate balanced burner operation, uniform flame distribution
                                and satisfactory combustion.

                            </p>

                            <p>

                                Bridgewall temperature represents the thermal condition above
                                the burner zone. Excessively high bridgewall temperatures may
                                indicate over-firing, localized flame impingement or excessive
                                heat release, while unusually low temperatures may indicate poor
                                burner efficiency or insufficient firing.

                            </p>

                            <p>

                                Firebox draft is one of the most important operating variables.
                                Atmospheric crude furnaces normally operate with a slight
                                negative draft to prevent hot combustion gases from escaping
                                through observation doors and casing openings.

                            </p>

                            <p>

                                Damper position controls combustion gas flow through the furnace.
                                Excessive opening generally increases stack losses, whereas
                                insufficient opening may result in poor draft, unstable flames
                                and incomplete combustion.

                            </p>

                            <h3>Engineering Assessment</h3>

                            <table className="receipt-table">

                                <thead>

                                    <tr>

                                        <th>Parameter</th>
                                        <th>Recommended Practice</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr>

                                        <td>Firebox Draft</td>

                                        <td>

                                            Slight negative draft should be maintained for safe
                                            furnace operation.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Bridgewall Temperature</td>

                                        <td>

                                            Stable operation is preferred. Rapid increases may
                                            indicate burner imbalance or excessive firing.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Damper Position</td>

                                        <td>

                                            Adjust to maintain proper draft while minimizing
                                            stack heat losses.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Radiation Zone</td>

                                        <td>

                                            Uniform heat release improves tube life and minimizes
                                            coke formation.

                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                            <br />

                            <strong>Applicable Engineering Standards</strong>

                            <ul>

                                <li>
                                    API Standard 560 – Fired Heaters for General Refinery Service
                                </li>

                                <li>
                                    API RP 535 – Burners for Fired Heaters
                                </li>

                                <li>
                                    API RP 556 – Instrumentation and Control Systems for Fired Heaters
                                </li>

                                <li>
                                    NFPA 85 – Boiler and Combustion Systems Hazards Code
                                </li>

                            </ul>

                        </div>

                    </div>

                )}




                {/* ==========================================================
   PAGE 3 – CONVECTION SECTION & AIR PREHEATER
========================================================== */}

                {currentPage === 3 && (

                    <div>

                        <h2
                            style={{
                                textAlign: "center",
                                color: "#0b5ed7"
                            }}
                        >
                            CONVECTION SECTION & COMBUSTION AIR SYSTEM
                        </h2>

                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Flue Gas Temperature</td>

                                    <td>
                                        {Number(convection.flueGasTemperature || 0).toFixed(1)} °C
                                    </td>

                                </tr>

                                <tr>

                                    <td>Flue Gas Pressure</td>

                                    <td>
                                        {Number(convection.flueGasPressure || 0).toFixed(3)} kPag
                                    </td>

                                </tr>

                                <tr>

                                    <td>Combustion Air Temperature</td>

                                    <td>
                                        {Number(convection.combustionAirTemperature || 0).toFixed(1)} °C
                                    </td>

                                </tr>

                                <tr>

                                    <td>Atmospheric Air Temperature</td>

                                    <td>
                                        {Number(convection.atmosphericAir || 0).toFixed(1)} °C
                                    </td>

                                </tr>

                                <tr>

                                    <td>B-201 FD Fan</td>

                                    <td>

                                        {convection.blowerB201
                                            ? "RUNNING"
                                            : "STOPPED"}

                                    </td>

                                </tr>

                                <tr>

                                    <td>B-202 FD Fan</td>

                                    <td>

                                        {convection.blowerB202
                                            ? "RUNNING"
                                            : "STOPPED"}

                                    </td>

                                </tr>

                                <tr>

                                    <td>Combustion Air Valve</td>

                                    <td>
                                        {Number(convection.airValve || 0).toFixed(1)} %
                                    </td>

                                </tr>

                                <tr>

                                    <td>Flue Gas Damper Valve</td>

                                    <td>
                                        {Number(convection.flueValve || 0).toFixed(1)} %
                                    </td>

                                </tr>

                                <tr>

                                    <td>Air Temperature Rise</td>

                                    <td>

                                        {Number(

                                            (convection.combustionAirTemperature || 0) -

                                            (convection.atmosphericAir || 0)

                                        ).toFixed(1)} °C

                                    </td>

                                </tr>

                            </tbody>

                        </table>

                        <br />

                        <div
                            style={{
                                background: "#eef7ff",
                                padding: 20,
                                borderRadius: 8,
                                lineHeight: 1.8,
                                fontSize: 14
                            }}
                        >

                            <h3>Engineering Interpretation</h3>

                            <p>

                                The convection section recovers sensible heat from hot flue
                                gases after they leave the radiant section. Instead of allowing
                                this valuable heat to escape through the stack, it is recovered
                                to preheat combustion air and process streams, thereby improving
                                overall furnace thermal efficiency.

                            </p>

                            <p>

                                Increasing combustion air temperature reduces the amount of fuel
                                required to reach burner flame temperature. Consequently,
                                properly functioning air preheaters improve fuel economy while
                                reducing stack losses.

                            </p>

                            <p>

                                The Forced Draft (FD) blowers B-201 and B-202 provide combustion
                                air required by the burners. At least one blower should normally
                                remain in service, while the second blower serves as standby or
                                additional capacity depending on refinery operating philosophy.

                            </p>

                            <p>

                                Combustion air valve opening directly regulates airflow supplied
                                to the burners. Excessive airflow increases oxygen content in the
                                stack and reduces thermal efficiency, whereas insufficient
                                airflow results in incomplete combustion, flame instability,
                                carbon monoxide formation and possible soot deposition.

                            </p>

                            <p>

                                Proper balancing between combustion air supply and flue gas
                                discharge is essential for maintaining stable furnace draft,
                                efficient burner operation and maximum heat recovery.

                            </p>

                            <h3>Operational Assessment</h3>

                            <table className="receipt-table">

                                <thead>

                                    <tr>

                                        <th>Equipment</th>
                                        <th>Engineering Assessment</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr>

                                        <td>Convection Section</td>

                                        <td>

                                            Maximizes recovery of waste heat before flue gases
                                            enter the stack.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Air Preheater</td>

                                        <td>

                                            Higher combustion air temperature generally improves
                                            furnace efficiency and reduces fuel consumption.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>FD Blowers</td>

                                        <td>

                                            Stable blower operation ensures continuous combustion
                                            air supply to all burners.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Combustion Air Valve</td>

                                        <td>

                                            Should be adjusted to achieve optimum excess oxygen
                                            while minimizing stack heat losses.

                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                            <br />

                            <strong>Applicable Engineering Standards</strong>

                            <ul>

                                <li>API Standard 560 – Fired Heaters for General Refinery Service</li>

                                <li>API RP 535 – Burner Management and Combustion Systems</li>

                                <li>NFPA 85 – Boiler and Combustion Systems Hazards Code</li>

                                <li>ASME PTC 4 – Fired Steam Generators Performance Test Code</li>

                            </ul>

                        </div>

                    </div>

                )}



                {/* ==========================================================
   PAGE 4 – STACK SYSTEM & DRAFT ANALYSIS
========================================================== */}

                {currentPage === 4 && (

                    <div>

                        <h2
                            style={{
                                textAlign: "center",
                                color: "#0b5ed7"
                            }}
                        >
                            STACK SYSTEM & DRAFT ANALYSIS
                        </h2>

                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td>Stack Gas Temperature</td>

                                    <td>

                                        {Number(stack.temperature || 0).toFixed(1)} °C

                                    </td>

                                </tr>

                                <tr>

                                    <td>Stack Pressure</td>

                                    <td>

                                        {Number(stack.pressure || 0).toFixed(3)} kPag

                                    </td>

                                </tr>

                                <tr>

                                    <td>Stack Condition</td>

                                    <td>

                                        {stack.condition || "N/A"}

                                    </td>

                                </tr>

                                <tr>

                                    <td>Draft Status</td>

                                    <td>

                                        {stack.draftStatus || "N/A"}

                                    </td>

                                </tr>

                            </tbody>

                        </table>

                        <br />

                        <div
                            style={{
                                background: "#eef7ff",
                                padding: 20,
                                borderRadius: 8,
                                lineHeight: 1.8,
                                fontSize: 14
                            }}
                        >

                            <h3>Engineering Interpretation</h3>

                            <p>

                                The stack system provides the driving force that removes combustion
                                products from the furnace while maintaining the desired furnace draft.
                                Proper draft ensures that combustion gases move smoothly from the
                                radiant section through the convection section before exiting safely
                                through the stack.

                            </p>

                            <p>

                                A fired heater normally operates with a slight negative pressure inside
                                the firebox. This prevents hot combustion gases and flames from escaping
                                through inspection doors, burner openings and tube penetrations while
                                allowing stable combustion throughout the furnace.

                            </p>

                            <p>

                                High stack temperature generally indicates increased heat loss through
                                the stack. Excessively high values often suggest fouled convection tubes,
                                poor heat recovery, excessive excess air or inadequate combustion control.

                            </p>

                            <p>

                                Very low stack temperatures may improve efficiency but should remain
                                above the acid dew point to avoid sulfuric acid condensation and severe
                                low-temperature corrosion within the stack and downstream ductwork.

                            </p>

                            <p>

                                Draft pressure should remain sufficiently negative to maintain safe
                                combustion but not excessively negative, as excessive draft increases
                                air infiltration and unnecessary fuel consumption.

                            </p>

                            <h3>Operational Assessment</h3>

                            <table className="receipt-table">

                                <thead>

                                    <tr>

                                        <th>Parameter</th>

                                        <th>Engineering Assessment</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr>

                                        <td>Stack Temperature</td>

                                        <td>

                                            Represents unrecovered energy leaving the fired heater.
                                            Lower values generally indicate better heat recovery.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Negative Draft</td>

                                        <td>

                                            Preferred operating condition for refinery fired heaters.
                                            Maintains safe inward air leakage.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Positive Draft</td>

                                        <td>

                                            Undesirable condition that may force flames or hot gases
                                            out through furnace openings.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Stack Pressure</td>

                                        <td>

                                            Should remain stable with minimal fluctuations during
                                            steady-state operation.

                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                            <br />

                            <h3>Typical Engineering Guidelines</h3>

                            <table className="receipt-table">

                                <thead>

                                    <tr>

                                        <th>Item</th>

                                        <th>Recommended Practice</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr>

                                        <td>Firebox Draft</td>

                                        <td>

                                            Slightly negative during normal operation.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Stack Temperature</td>

                                        <td>

                                            Keep as low as practical while remaining above acid dew point.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Heat Recovery</td>

                                        <td>

                                            Monitor convection section performance continuously.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Draft Stability</td>

                                        <td>

                                            Large pressure swings normally indicate damper or fan control issues.

                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                            <br />

                            <strong>Applicable Engineering Standards</strong>

                            <ul>

                                <li>API Standard 560 – Fired Heaters for General Refinery Service</li>

                                <li>API RP 535 – Burner Management Systems</li>

                                <li>NFPA 85 – Boiler and Combustion Systems Hazards Code</li>

                                <li>ASME PTC 4 – Fired Heater Performance Testing</li>

                                <li>ISO 13705 – Petroleum and Natural Gas Industries – Fired Heaters</li>

                            </ul>

                        </div>

                    </div>

                )}



                {/* ==========================================================
   PAGE 5 – FUEL SYSTEM ANALYSIS
========================================================== */}

                {currentPage === 5 && (

                    <div>

                        <h2
                            style={{
                                textAlign: "center",
                                color: "#0b5ed7"
                            }}
                        >
                            FUEL SYSTEM PERFORMANCE
                        </h2>

                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>Fuel Source</th>

                                    <th>Flow</th>

                                    <th>Pressure</th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr>

                                    <td>Fuel Gas</td>

                                    <td>

                                        {Number(fuel.fuelGasFlow || 0).toFixed(2)} Nm³/hr

                                    </td>

                                    <td>

                                        {Number(fuel.fuelGasPressure || 0).toFixed(3)} barg

                                    </td>

                                </tr>

                                <tr>

                                    <td>Compressed Natural Gas (CNG)</td>

                                    <td>

                                        {Number(fuel.CNGFlow || 0).toFixed(2)} Nm³/hr

                                    </td>

                                    <td>

                                        {Number(fuel.CNGPressure || 0).toFixed(3)} barg

                                    </td>

                                </tr>

                                <tr>

                                    <td>Fuel Oil</td>

                                    <td>

                                        {Number(fuel.fuelOilFlow || 0).toFixed(2)} L/hr

                                    </td>

                                    <td>

                                        {Number(fuel.fuelOilPressure || 0).toFixed(3)} barg

                                    </td>

                                </tr>

                                <tr>

                                    <td>Atomizing Steam</td>

                                    <td>

                                        {Number(fuel.atomizingSteamFlow || 0).toFixed(2)} kg/hr

                                    </td>

                                    <td>

                                        {Number(fuel.atomizingSteamPressure || 0).toFixed(3)} barg

                                    </td>

                                </tr>

                                <tr>

                                    <td>Fuel System Status</td>

                                    <td colSpan="2">

                                        <b>{fuel.status || "N/A"}</b>

                                    </td>

                                </tr>

                            </tbody>

                        </table>

                        <br />

                        <div
                            style={{
                                background: "#eef7ff",
                                padding: 20,
                                borderRadius: 8,
                                lineHeight: 1.8,
                                fontSize: 14
                            }}
                        >

                            <h3>Engineering Interpretation</h3>

                            <p>

                                The fuel system supplies the thermal energy required to maintain the
                                desired crude outlet temperature. Stable fuel pressure and flow are
                                essential for maintaining burner stability, efficient combustion and
                                uniform furnace heat distribution.

                            </p>

                            <p>

                                Fuel gas is generally the preferred refinery fuel because of its clean
                                combustion characteristics, rapid flame response and reduced maintenance
                                requirements.

                            </p>

                            <p>

                                Compressed Natural Gas (CNG) provides supplementary gaseous fuel during
                                periods of low refinery fuel gas availability and improves overall fuel
                                supply reliability.

                            </p>

                            <p>

                                Fuel oil is normally utilized as an alternative firing medium or during
                                startup, depending on refinery operating philosophy. Proper atomization
                                is required to obtain complete combustion and minimize soot formation.

                            </p>

                            <p>

                                Atomizing steam breaks liquid fuel into fine droplets, increasing the
                                available surface area for combustion. Poor atomization produces long
                                yellow flames, carbon deposits, incomplete combustion and reduced
                                thermal efficiency.

                            </p>

                            <h3>Operational Assessment</h3>

                            <table className="receipt-table">

                                <thead>

                                    <tr>

                                        <th>Parameter</th>

                                        <th>Engineering Assessment</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr>

                                        <td>Fuel Gas Flow</td>

                                        <td>

                                            Determines the primary heat released inside the radiant section.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Fuel Pressure</td>

                                        <td>

                                            Low pressure may result in unstable flames or burner trip.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Fuel Oil Pressure</td>

                                        <td>

                                            Maintains adequate atomization through burner nozzles.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Atomizing Steam</td>

                                        <td>

                                            Essential for complete combustion and reduced soot generation.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Fuel Status</td>

                                        <td>

                                            Provides immediate indication of burner firing condition.

                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                            <br />

                            <h3>Good Operating Practice</h3>

                            <ul>

                                <li>Maintain stable fuel pressure during all operating conditions.</li>

                                <li>Avoid sudden fuel flow fluctuations that may destabilize burner flames.</li>

                                <li>Maintain adequate atomizing steam whenever liquid fuel is fired.</li>

                                <li>Inspect burner tips periodically for coke or carbon deposition.</li>

                                <li>Verify burner flame pattern during routine operator rounds.</li>

                                <li>Confirm proper operation of all burner management interlocks.</li>

                            </ul>

                            <br />

                            <strong>Applicable Engineering Standards</strong>

                            <ul>

                                <li>API Standard 560 – Fired Heaters for General Refinery Service</li>

                                <li>API RP 556 – Instrumentation and Control Systems</li>

                                <li>NFPA 85 – Boiler and Combustion Systems Hazards Code</li>

                                <li>IEC 61511 – Safety Instrumented Systems</li>

                                <li>ISO 13705 – Petroleum and Natural Gas Industries – Fired Heaters</li>

                            </ul>

                        </div>

                    </div>

                )}


                {/* ==========================================================
   PAGE 6 – OVERALL FURNACE PERFORMANCE
========================================================== */}

                {currentPage === 6 && (

                    <div>

                        <h2
                            style={{
                                textAlign: "center",
                                color: "#0b5ed7"
                            }}
                        >
                            OVERALL FURNACE PERFORMANCE EVALUATION
                        </h2>

                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>Performance Item</th>

                                    <th>Current Value</th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr>

                                    <td>Furnace Status</td>

                                    <td>

                                        <b>{performance.furnaceStatus || "N/A"}</b>

                                    </td>

                                </tr>

                                <tr>

                                    <td>Steam Generation</td>

                                    <td>

                                        {performance.steamGenerationStatus || "N/A"}

                                    </td>

                                </tr>

                                <tr>

                                    <td>Radiation Zone</td>

                                    <td>

                                        {performance.radiationZoneStatus || "N/A"}

                                    </td>

                                </tr>

                                <tr>

                                    <td>Stack Condition</td>

                                    <td>

                                        {performance.stackCondition || "N/A"}

                                    </td>

                                </tr>

                                <tr>

                                    <td>Draft Condition</td>

                                    <td>

                                        {performance.furnaceDraftStatus || "N/A"}

                                    </td>

                                </tr>

                                <tr>

                                    <td>Crude Temperature Rise</td>

                                    <td>

                                        {Number(performance.crudeTemperatureRise || 0).toFixed(1)} °C

                                    </td>

                                </tr>

                                <tr>

                                    <td>Steam Temperature Rise</td>

                                    <td>

                                        {Number(performance.steamTemperatureRise || 0).toFixed(1)} °C

                                    </td>

                                </tr>

                                <tr>

                                    <td>Steam Pressure Drop</td>

                                    <td>

                                        {Number(performance.steamPressureDrop || 0).toFixed(3)} barg

                                    </td>

                                </tr>

                            </tbody>

                        </table>

                        <br />

                        <div
                            style={{
                                background: "#eef7ff",
                                padding: 20,
                                borderRadius: 8,
                                lineHeight: 1.8,
                                fontSize: 14
                            }}
                        >

                            <h3>Engineering Evaluation</h3>

                            <p>

                                Overall furnace performance is determined by the ability of the fired
                                heater to transfer combustion heat efficiently to the process fluid while
                                maintaining safe operation, stable combustion and minimum fuel
                                consumption.

                            </p>

                            <p>

                                The crude temperature rise represents the effective heat absorbed by the
                                crude oil as it passes through both the radiant and convection sections.
                                This value is one of the primary indicators of fired heater performance.

                            </p>

                            <p>

                                Steam generation performance reflects the effectiveness of waste heat
                                recovery from the convection section. Efficient utilization of this heat
                                reduces overall refinery energy consumption and improves thermal
                                efficiency.

                            </p>

                            <p>

                                Stack condition and furnace draft collectively indicate whether
                                combustion gases are leaving the furnace under acceptable operating
                                conditions while minimizing heat losses.

                            </p>

                            <p>

                                The overall operating objective is to maximize heat transfer to the crude
                                while minimizing stack losses, fuel consumption, tube metal temperatures
                                and combustion instability.

                            </p>

                            <h3>Performance Assessment Matrix</h3>

                            <table className="receipt-table">

                                <thead>

                                    <tr>

                                        <th>Area</th>

                                        <th>Engineering Meaning</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr>

                                        <td>Crude Heating</td>

                                        <td>

                                            Measures useful process heat delivered to the crude charge.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Steam Generation</td>

                                        <td>

                                            Measures efficiency of convection-section heat recovery.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Draft Control</td>

                                        <td>

                                            Indicates combustion stability and furnace safety.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Stack Condition</td>

                                        <td>

                                            Represents overall heat losses leaving the furnace.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Radiation Section</td>

                                        <td>

                                            Represents primary heat release inside the firebox.

                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                            <br />

                            <h3>Engineering Recommendations</h3>

                            <ul>

                                <li>Maintain stable burner firing rates during steady-state operation.</li>

                                <li>Continuously monitor crude outlet temperature to prevent tube overheating.</li>

                                <li>Optimize excess air to improve combustion efficiency while avoiding excessive stack losses.</li>

                                <li>Maintain stable furnace draft using proper damper control.</li>

                                <li>Clean convection tubes periodically to improve heat recovery.</li>

                                <li>Monitor steam production to verify waste heat recovery efficiency.</li>

                                <li>Investigate abnormal temperature rise or pressure loss immediately.</li>

                            </ul>

                            <br />

                            <strong>Applicable Engineering Standards</strong>

                            <ul>

                                <li>API Standard 560 – Fired Heaters for General Refinery Service</li>

                                <li>ASME Section VIII</li>

                                <li>ASME PTC 4 – Fired Heater Performance Test Code</li>

                                <li>ISO 13705 – Fired Heaters for Petroleum Refineries</li>

                                <li>API RP 535 – Burner Management Systems</li>

                            </ul>

                        </div>

                    </div>

                )}


                {/* ==========================================================
   PAGE 7 – FURNACE SAFETY & OPERATIONAL INTEGRITY
========================================================== */}

                {currentPage === 7 && (

                    <div>

                        <h2
                            style={{
                                textAlign: "center",
                                color: "#0b5ed7"
                            }}
                        >
                            FURNACE SAFETY & OPERATIONAL INTEGRITY
                        </h2>

                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>Safety Parameter</th>

                                    <th>Current Status</th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr>

                                    <td>Furnace Operating Status</td>

                                    <td>

                                        <b>{performance.furnaceStatus || "N/A"}</b>

                                    </td>

                                </tr>

                                <tr>

                                    <td>Fuel System</td>

                                    <td>

                                        {fuel.status || "N/A"}

                                    </td>

                                </tr>

                                <tr>

                                    <td>Draft Condition</td>

                                    <td>

                                        {performance.furnaceDraftStatus || "N/A"}

                                    </td>

                                </tr>

                                <tr>

                                    <td>Radiation Section</td>

                                    <td>

                                        {performance.radiationZoneStatus || "N/A"}

                                    </td>

                                </tr>

                                <tr>

                                    <td>Steam Generation</td>

                                    <td>

                                        {steam.status || "N/A"}

                                    </td>

                                </tr>

                                <tr>

                                    <td>Stack Condition</td>

                                    <td>

                                        {stack.condition || "N/A"}

                                    </td>

                                </tr>

                            </tbody>

                        </table>

                        <br />

                        <div
                            style={{
                                background: "#eef7ff",
                                padding: 20,
                                borderRadius: 8,
                                lineHeight: 1.8,
                                fontSize: 14
                            }}
                        >

                            <h3>Operational Safety Philosophy</h3>

                            <p>

                                A fired heater contains one of the highest fire and explosion risks in a
                                refinery. Safe operation depends on maintaining proper combustion,
                                adequate furnace draft, reliable fuel supply and effective burner
                                management throughout the operating cycle.

                            </p>

                            <p>

                                The burner management philosophy ensures that fuel cannot accumulate
                                inside the furnace before ignition. Every burner must be ignited only
                                after proper furnace purging has been completed.

                            </p>

                            <p>

                                Loss of draft, excessive bridgewall temperature, burner flame failure or
                                fuel pressure instability may rapidly create unsafe operating conditions
                                requiring immediate operator response or automatic shutdown by the Burner
                                Management System (BMS).

                            </p>

                            <h3>Primary Furnace Protection Systems</h3>

                            <table className="receipt-table">

                                <thead>

                                    <tr>

                                        <th>Protection System</th>

                                        <th>Purpose</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr>

                                        <td>Burner Management System</td>

                                        <td>

                                            Controls safe burner startup, shutdown and flame supervision.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Flame Scanner</td>

                                        <td>

                                            Continuously confirms burner flame presence.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Fuel Shutoff Valves</td>

                                        <td>

                                            Automatically isolate fuel during unsafe conditions.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Draft Monitoring</td>

                                        <td>

                                            Maintains negative furnace pressure.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Stack Monitoring</td>

                                        <td>

                                            Monitors combustion gas discharge conditions.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Combustion Air Control</td>

                                        <td>

                                            Maintains proper air-fuel ratio.

                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                            <br />

                            <h3>Typical Furnace Trip Conditions</h3>

                            <ul>

                                <li>Complete flame failure.</li>

                                <li>Loss of combustion air supply.</li>

                                <li>Loss of induced draft.</li>

                                <li>High bridgewall or radiant section temperature.</li>

                                <li>High furnace pressure.</li>

                                <li>Fuel gas pressure below safe operating limit.</li>

                                <li>Burner Management System fault.</li>

                                <li>Emergency Shutdown (ESD) activation.</li>

                            </ul>

                            <br />

                            <h3>Operator Responsibilities</h3>

                            <ul>

                                <li>Confirm proper furnace purge before ignition.</li>

                                <li>Verify stable flame at all burners.</li>

                                <li>Monitor bridgewall temperature continuously.</li>

                                <li>Observe furnace draft trend.</li>

                                <li>Check stack temperature for abnormal heat losses.</li>

                                <li>Confirm burner flames remain blue and stable.</li>

                                <li>Respond immediately to burner alarms.</li>

                                <li>Never bypass Burner Management interlocks.</li>

                            </ul>

                            <br />

                            <strong>Applicable Engineering Standards</strong>

                            <ul>

                                <li>API Standard 560 – Fired Heaters</li>

                                <li>NFPA 85 – Boiler & Combustion Systems Hazards Code</li>

                                <li>IEC 61511 – Safety Instrumented Systems</li>

                                <li>API RP 556 – Instrumentation & Control</li>

                                <li>ISO 13705 – Fired Heaters for Petroleum Refineries</li>

                                <li>API Recommended Practice 535 – Burner Management Systems</li>

                            </ul>

                        </div>

                    </div>

                )}



                {/* ==========================================================
   PAGE 8 – THERMAL PERFORMANCE & ENERGY ASSESSMENT
========================================================== */}

                {currentPage === 8 && (

                    <div>

                        <h2
                            style={{
                                textAlign: "center",
                                color: "#0b5ed7"
                            }}
                        >
                            THERMAL PERFORMANCE & ENERGY ASSESSMENT
                        </h2>

                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>Performance Indicator</th>

                                    <th>Current Value</th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr>

                                    <td>Crude Temperature Rise</td>

                                    <td>

                                        {Number(performance.crudeTemperatureRise || 0).toFixed(1)} °C

                                    </td>

                                </tr>

                                <tr>

                                    <td>Steam Temperature Rise</td>

                                    <td>

                                        {Number(performance.steamTemperatureRise || 0).toFixed(1)} °C

                                    </td>

                                </tr>

                                <tr>

                                    <td>Steam Pressure Drop</td>

                                    <td>

                                        {Number(performance.steamPressureDrop || 0).toFixed(3)} bar

                                    </td>

                                </tr>

                                <tr>

                                    <td>Radiation Zone</td>

                                    <td>

                                        {performance.radiationZoneStatus || "N/A"}

                                    </td>

                                </tr>

                                <tr>

                                    <td>Stack Condition</td>

                                    <td>

                                        {performance.stackCondition || "N/A"}

                                    </td>

                                </tr>

                                <tr>

                                    <td>Overall Furnace Status</td>

                                    <td>

                                        {performance.furnaceStatus || "N/A"}

                                    </td>

                                </tr>

                            </tbody>

                        </table>

                        <br />

                        <div
                            style={{
                                background: "#eef7ff",
                                padding: 20,
                                borderRadius: 8,
                                lineHeight: 1.8,
                                fontSize: 14
                            }}
                        >

                            <h3>Thermal Performance Evaluation</h3>

                            <p>

                                The furnace converts chemical energy contained in the fuel into useful
                                thermal energy for heating crude oil while simultaneously generating
                                superheated steam. Overall thermal performance depends on combustion
                                efficiency, heat transfer efficiency and minimization of stack losses.

                            </p>

                            <p>

                                A high crude temperature rise generally indicates effective radiant heat
                                transfer, while excessive stack temperature normally indicates useful heat
                                escaping through the stack instead of being transferred into the process.

                            </p>

                            <p>

                                Steam temperature rise reflects the effectiveness of the convection
                                section. Stable steam generation with minimal pressure losses normally
                                indicates clean convection tubes and satisfactory heat recovery.

                            </p>

                            <h3>Major Sources of Heat Loss</h3>

                            <table className="receipt-table">

                                <thead>

                                    <tr>

                                        <th>Heat Loss Mechanism</th>

                                        <th>Operational Impact</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr>

                                        <td>High Stack Temperature</td>

                                        <td>

                                            Loss of recoverable heat to atmosphere.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Excess Combustion Air</td>

                                        <td>

                                            Additional energy required to heat unused air.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Radiation Losses</td>

                                        <td>

                                            Heat escaping through furnace casing.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Tube Fouling</td>

                                        <td>

                                            Lower heat transfer coefficient.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Incomplete Combustion</td>

                                        <td>

                                            Fuel energy not completely released.

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Air Leakage</td>

                                        <td>

                                            Reduced combustion efficiency.

                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                            <br />

                            <h3>Typical Refinery Energy Optimisation Measures</h3>

                            <ul>

                                <li>Maintain optimum excess oxygen.</li>

                                <li>Keep burners properly tuned.</li>

                                <li>Monitor bridgewall and stack temperatures.</li>

                                <li>Inspect refractory for hot spots.</li>

                                <li>Remove tube fouling during shutdown.</li>

                                <li>Optimize damper position.</li>

                                <li>Maintain stable furnace draft.</li>

                                <li>Recover maximum heat in convection section.</li>

                                <li>Maintain clean burner tips.</li>

                                <li>Reduce unnecessary steam consumption.</li>

                            </ul>

                            <br />

                            <h3>Engineering Interpretation</h3>

                            <p>

                                API Standard 560 recommends continuous monitoring of thermal
                                performance to identify efficiency deterioration before production is
                                affected. Progressive increases in stack temperature or decreasing crude
                                outlet temperature generally indicate fouling, poor combustion or heat
                                losses requiring maintenance intervention.

                            </p>

                            <p>

                                Continuous monitoring of steam temperature rise provides an excellent
                                indicator of convection-section cleanliness. Increasing steam pressure
                                drop may suggest fouling or flow restriction inside the superheater
                                coils.

                            </p>

                            <br />

                            <strong>Applicable Standards</strong>

                            <ul>

                                <li>API Standard 560 – Fired Heaters</li>

                                <li>ISO 13705 – Fired Process Heaters</li>

                                <li>API RP 535 – Burner Management</li>

                                <li>ASME PTC 4 – Fired Steam Generator Performance Test Code</li>

                                <li>ASME Section I – Power Boilers</li>

                            </ul>

                        </div>

                    </div>

                )}



                {/* ==========================================================
   PAGE 9 – ENGINEERING ASSESSMENT & MAINTENANCE RECOMMENDATIONS
========================================================== */}

                {currentPage === 9 && (

                    <div>

                        <h2
                            style={{
                                textAlign: "center",
                                color: "#0b5ed7"
                            }}
                        >
                            ENGINEERING ASSESSMENT & MAINTENANCE RECOMMENDATIONS
                        </h2>

                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>Engineering Item</th>

                                    <th>Current Assessment</th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr>

                                    <td>Overall Furnace Status</td>

                                    <td>{performance.furnaceStatus || "N/A"}</td>

                                </tr>

                                <tr>

                                    <td>Fuel System</td>

                                    <td>{fuel.status || "N/A"}</td>

                                </tr>

                                <tr>

                                    <td>Radiation Section</td>

                                    <td>{performance.radiationZoneStatus || "N/A"}</td>

                                </tr>

                                <tr>

                                    <td>Steam Generation</td>

                                    <td>{steam.status || "N/A"}</td>

                                </tr>

                                <tr>

                                    <td>Draft System</td>

                                    <td>{performance.furnaceDraftStatus || "N/A"}</td>

                                </tr>

                                <tr>

                                    <td>Stack Performance</td>

                                    <td>{performance.stackCondition || "N/A"}</td>

                                </tr>

                            </tbody>

                        </table>

                        <br />

                        <div
                            style={{
                                background: "#eef7ff",
                                padding: 20,
                                borderRadius: 8,
                                lineHeight: 1.8,
                                fontSize: 14
                            }}
                        >

                            <h3>Engineering Assessment</h3>

                            <p>

                                The fired heater remains one of the most critical energy conversion
                                equipment in the refinery. Stable operation depends on maintaining the
                                correct balance between fuel supply, combustion air, furnace draft,
                                radiant heat transfer and convection heat recovery.

                            </p>

                            <p>

                                Process variables evaluated in this report indicate the operating
                                condition of the combustion system, heat transfer surfaces, steam
                                generation section and exhaust system. Continuous monitoring allows
                                abnormal operating trends to be detected before equipment reliability or
                                process throughput is affected.

                            </p>

                            <h3>Routine Operator Recommendations</h3>

                            <ul>

                                <li>Verify burner flame stability every operating shift.</li>

                                <li>Monitor bridgewall and radiant temperatures continuously.</li>

                                <li>Observe furnace draft before adjusting fuel rates.</li>

                                <li>Inspect stack temperature trends for increasing heat losses.</li>

                                <li>Maintain proper air-to-fuel ratio.</li>

                                <li>Confirm blower operation before increasing firing rate.</li>

                                <li>Respond immediately to abnormal burner behaviour.</li>

                                <li>Avoid unnecessary rapid firing rate changes.</li>

                            </ul>

                            <br />

                            <h3>Mechanical Maintenance Recommendations</h3>

                            <ul>

                                <li>Inspect burner tips for fouling and carbon deposits.</li>

                                <li>Inspect refractory lining for cracks and hot spots.</li>

                                <li>Verify damper actuator calibration.</li>

                                <li>Inspect expansion joints during shutdown.</li>

                                <li>Clean convection tubes during scheduled maintenance.</li>

                                <li>Inspect radiant tubes for bulging and creep.</li>

                                <li>Perform tube thickness measurements periodically.</li>

                                <li>Inspect fuel valves for leakage.</li>

                            </ul>

                            <br />

                            <h3>Instrumentation Recommendations</h3>

                            <ul>

                                <li>Calibrate all temperature transmitters.</li>

                                <li>Verify pressure transmitter accuracy.</li>

                                <li>Test burner flame scanners.</li>

                                <li>Verify combustion air flow indication.</li>

                                <li>Test Burner Management System interlocks.</li>

                                <li>Validate emergency shutdown logic.</li>

                                <li>Verify stack monitoring instruments.</li>

                                <li>Perform annual instrument proof testing.</li>

                            </ul>

                            <br />

                            <h3>Reliability Improvement Opportunities</h3>

                            <table className="receipt-table">

                                <thead>

                                    <tr>

                                        <th>Opportunity</th>

                                        <th>Expected Benefit</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr>

                                        <td>Improve burner tuning</td>

                                        <td>Higher combustion efficiency.</td>

                                    </tr>

                                    <tr>

                                        <td>Optimize excess oxygen</td>

                                        <td>Lower fuel consumption.</td>

                                    </tr>

                                    <tr>

                                        <td>Improve refractory condition</td>

                                        <td>Reduced radiation heat loss.</td>

                                    </tr>

                                    <tr>

                                        <td>Regular tube cleaning</td>

                                        <td>Improved heat transfer.</td>

                                    </tr>

                                    <tr>

                                        <td>Predictive maintenance</td>

                                        <td>Reduced unplanned shutdowns.</td>

                                    </tr>

                                    <tr>

                                        <td>Trend monitoring</td>

                                        <td>Early fault detection.</td>

                                    </tr>

                                </tbody>

                            </table>

                            <br />

                            <h3>Applicable Engineering References</h3>

                            <ul>

                                <li>API Standard 560 – Fired Heaters</li>

                                <li>API RP 556 – Instrumentation and Control Systems</li>

                                <li>API RP 535 – Burner Management Systems</li>

                                <li>NFPA 85 – Boiler and Combustion Systems Hazards Code</li>

                                <li>ISO 13705 – Fired Process Heaters</li>

                                <li>ASME Section VIII</li>

                                <li>ASME Section I</li>

                                <li>IEC 61511 – Safety Instrumented Systems</li>

                            </ul>

                        </div>

                    </div>

                )}


                {/* ==========================================================
   PAGE 10 – REPORT CERTIFICATION & DIGITAL AUTHENTICATION
========================================================== */}

                {currentPage === 10 && (

                    <div>

                        <h2
                            style={{
                                textAlign: "center",
                                color: "#0b5ed7"
                            }}
                        >
                            REPORT CERTIFICATION & DIGITAL AUTHENTICATION
                        </h2>

                        <br />

                        <table className="receipt-table">

                            <tbody>

                                <tr>

                                    <td><b>Report Number</b></td>

                                    <td>{report.reportNumber}</td>

                                </tr>

                                <tr>

                                    <td><b>Generated On</b></td>

                                    <td>{report.generated}</td>

                                </tr>

                                <tr>

                                    <td><b>System</b></td>

                                    <td>NK Refinery Digital Twin System</td>

                                </tr>

                                <tr>

                                    <td><b>Equipment</b></td>

                                    <td>Fired Heater / Crude Furnace</td>

                                </tr>

                                <tr>

                                    <td><b>Report Type</b></td>

                                    <td>Furnace Performance Engineering Report</td>

                                </tr>

                                <tr>

                                    <td><b>Revision</b></td>

                                    <td>Revision 1.0</td>

                                </tr>

                                <tr>

                                    <td><b>Status</b></td>

                                    <td>Automatically Generated</td>

                                </tr>

                            </tbody>

                        </table>

                        <br />

                        <div
                            style={{
                                marginTop: 35,
                                padding: 15,
                                background: "#f4f6f8",
                                borderLeft: "5px solid #0B4F9C"
                            }}
                        >


                            <strong>
                                Engineering Summary:
                            </strong>


                            <br /><br />


                            The furnace performance assessment indicates that current operating
                            conditions should be reviewed against combustion efficiency,
                            draft stability, heat recovery performance and steam generation duty.


                            Continuous monitoring of firebox temperature, crude outlet temperature,
                            stack temperature, excess air and burner parameters is recommended
                            for optimum furnace reliability.


                        </div>
                        <br />

                        <div
                            style={{
                                background: "#eef7ff",
                                padding: 20,
                                borderRadius: 8,
                                lineHeight: 1.9,
                                fontSize: 14
                            }}
                        >

                            <h3>Engineering Certification</h3>

                            <p>

                                This report has been automatically generated by the NK Refinery Digital
                                Twin System using live process information obtained from the simulated
                                Distributed Control System (DCS). The calculations presented are based on
                                real-time operating conditions, engineering correlations, equipment
                                performance models and refinery operating philosophy implemented within
                                the digital twin environment.

                            </p>

                            <p>

                                The report is intended to assist refinery engineers, control room
                                operators, process engineers, maintenance engineers and technical
                                personnel in evaluating fired heater operating performance, combustion
                                efficiency, steam generation, thermal performance, equipment integrity
                                and operational safety.

                            </p>

                            <p>

                                This report should be reviewed together with field inspections, operating
                                procedures, maintenance records and engineering judgement before making
                                any operational decisions.

                            </p>

                            <br />

                            <h3>Engineering Disclaimer</h3>

                            <p>

                                The NK Refinery Digital Twin System is designed primarily for process
                                simulation, operator training, engineering studies, process optimization
                                and educational purposes.

                                Although every effort has been made to ensure engineering consistency,
                                the results generated by the simulator should not replace plant operating
                                procedures, Process Safety Management (PSM), Management of Change (MOC),
                                Hazard and Operability (HAZOP) studies or engineering verification
                                required for actual refinery operation.

                            </p>

                            <br />

                            <h3>Applicable Engineering Standards</h3>

                            <ul>

                                <li>API Standard 560 — Fired Heaters for General Refinery Service</li>

                                <li>API RP 535 — Burner Management Systems</li>

                                <li>API RP 556 — Instrumentation and Control Systems</li>

                                <li>API 530 — Calculation of Heater Tube Thickness</li>

                                <li>NFPA 85 — Boiler and Combustion Systems Hazards Code</li>

                                <li>IEC 61511 — Functional Safety</li>

                                <li>ISO 13705 — Fired Process Heaters</li>

                                <li>ASME Section I</li>

                                <li>ASME Section VIII</li>

                            </ul>

                            <br />

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginTop: 40
                                }}
                            >

                                <div>

                                    <b>Prepared Automatically By</b>

                                    <br /><br />

                                    NK Refinery Digital Twin

                                    <br />

                                    Engineering Analytics Engine

                                </div>

                                <div>

                                    <b>Reviewed By</b>

                                    <br /><br />

                                    _____________________

                                    <br />

                                    Process Engineer

                                </div>

                                <div>

                                    <b>Approved By</b>

                                    <br /><br />

                                    _____________________

                                    <br />

                                    Operations Superintendent

                                </div>

                            </div>

                            <br /><br />

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}
                            >

                                <div>

                                    <QRCode
                                        value={JSON.stringify(report)}
                                        size={110}
                                    />

                                    <div
                                        style={{
                                            fontSize: 12,
                                            marginTop: 5,
                                            textAlign: "center"
                                        }}
                                    >

                                        Digital Verification

                                    </div>

                                </div>

                                <div>

                                    <Barcode
                                        value={report.reportNumber || "FURNACE"}
                                        height={50}
                                        width={1.6}
                                    />

                                </div>

                            </div>

                        </div>

                    </div>

                )}









                <hr />

                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: 25
                    }}
                >

                    <button
                        className="receipt-button"
                        disabled={currentPage === 0}
                        onClick={() => setCurrentPage(p => p - 1)}
                    >
                        ◀ Previous
                    </button>

                    <strong>
                        Page {currentPage + 1} of 11
                    </strong>

                    <button
                        className="receipt-button"
                        disabled={currentPage === 10}
                        onClick={() => setCurrentPage(p => p + 1)}
                    >
                        Next ▶
                    </button>

                </div>

                <br />

                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 20
                    }}
                >

                    <button
                        className="receipt-button"
                        onClick={() => window.print()}
                    >
                        Print
                    </button>

                    <button
                        className="receipt-button"
                    >
                        Export PDF
                    </button>

                    <button
                        className="receipt-button"
                        onClick={onClose}
                    >
                        Close
                    </button>

                </div>

            </div>

        </div>


    )

};

export default FurnacePerformance;